export interface RewardRetrievalTimelineStep {
  details: string;
  isFirst?: boolean;
  isCurrent?: boolean;
  isLast?: boolean;
  step: string;
  status: {
    icon: string;
    color: string;
    bgColor: string;
  };
}

export function useRewardRetrievalTimeline(params: {
  status?: string;
  retrievalInstruction?: string;
  t: (key: string) => string;
}): RewardRetrievalTimelineStep[] {
  const isDistributed = params.status === 'distributed';
  const retrievalInstruction = params.retrievalInstruction ?? '';

  return [
    {
      details: params.t('generic.requestedDetails'),
      isFirst: true,
      step: params.t('generic.requested'),
      status: {
        icon: 'check',
        color: '#03874C',
        bgColor: '#ECFDF3',
      },
    },
    {
      details: `${params.t('generic.retrieve')} ${retrievalInstruction}`.trim(),
      isCurrent: true,
      step: params.t('generic.awaiting'),
      status: {
        icon: isDistributed ? 'check' : 'clock',
        color: isDistributed ? '#03874C' : '#444CE7',
        bgColor: isDistributed ? '#ECFDF3' : '#EEF4FF',
      },
    },
    {
      details: params.t('generic.received'),
      isLast: true,
      step: params.t('generic.distributed'),
      status: {
        icon: isDistributed ? 'check' : 'clock',
        color: isDistributed ? '#03874C' : '#94A3B8',
        bgColor: isDistributed ? '#ECFDF3' : '#F8FAFC',
      },
    },
  ];
}
